// extracted by mini-css-extract-plugin
export var active = "_dx-7";
export var blink = "_dx-8";
export var dropDownSelector = "_dx-4";
export var dropDownWrapper = "_dx-3";
export var fakeCursor = "_dx-6";
export var fontSizeButton = "_dx-9";
export var formQuillEditor = "_dx-0";
export var pressed = "_dx-a";
export var qlBlank = "_dx-1";
export var textFormattingToolbar = "_dx-2";
export var textToolbarOption = "_dx-5";